import { Component } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  constructor(private oidcSecurityService: OidcSecurityService) { }
  loginWithCognito() {
    this.oidcSecurityService.authorize();
  }

}
